import './App.css';
import React, {useState} from 'react';
import { Card, Container, Grid } from '@material-ui/core';
import Profile from './components/layouts/Profile/Profile';
import Header from './components/Header/Header';
import Footer from './components/layouts/Footer/Footer';
import Routes from './Routes'
import Admin from './layouts/Admin'
import { makeStyles } from '@material-ui/core/styles'
import { BrowserRouter as Router, Route } from 'react-router-dom'
import ParticlesBg from 'particles-bg'
const useStyle = makeStyles(theme => ({
  space: {
    marginLeft: '4%',
    paddingLeft: '2%',
    marginBottom: '2%',
    [theme.breakpoints.down('sm')]: {
      marginLeft: '0',
      marginTop: '2%'
    },

  }
}))

function App() {
  const classes = useStyle();
  const [auth, setAuth] = useState(false)
  return (
    <Router>
      {
        auth ? (
          <Route path="/admin" component={Admin} />

        ) : (

          <Container >
          <ParticlesBg type="polygon" type="fountain" bg={true} />
            <Grid container style={{ marginTop: '5%' }}>
              <Grid item xs={12} sm={12} md={4} lg={3}>
                <Profile />
              </Grid>

              <Grid item xs sm>
                <Card className={classes.space}>
                  <Header />
                </Card>
                <Card className={classes.space}>
                  <Routes />                
                </Card>
                <Card className={classes.space}>
                  <Footer />
                </Card>
              </Grid>
            </Grid>
          </Container>
        )
      }
    </Router>
  );
}

export default App;
